<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header="<i class='fa fa-star'></i> Pembayaran Dashboard">
            <div v-if="isLoading" > 
            <center>
              <v-pulse></v-pulse>
            </center>
            </div>
            <div v-else class="table-responsive">

            <table class="table table-striped table-bordered table-hover" >
                <thead>
                  <tr>
                      <th>No</th> 
                      <th>Nama Funding</th>
                      <th>Nama User</th>
                      <th>Foto</th>
                      <th>Status</th>
                      <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="payments.length > 0">
                    <tr v-for="(value,index) in payments" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{value.title}}</td>
                        <td>{{value.name}}</td>
                        <td>
                            <b-img class="imageFile" thumbnail fluid :src="'https://res.cloudinary.com/wahyupermadie/image/fetch/c_fill,g_auto:face,h_120,w_120,fl_force_strip.progressive/f_webp/https://hackathon.futnet.id/transfer/'+value.foto" alt="Thumbnail" />
                        </td>
                        <td v-if="value.confirm == '0'">
                            <b-badge href="#" variant="danger">Belum Konfirmasi</b-badge>
                        </td>
                        <td v-else>
                            <b-badge href="#" variant="success">Confirmed</b-badge>
                        </td>
                        <td>
                            <button type="button" @click="confirm(value.id)" class="btn btn-xs btn-outline-warning"><span class="fa fa-pencil"></span></button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <td colspan="6">
                        <center>
                            Tidak Ada Data
                        </center>
                    </td>
                </tbody>
              </table>
            </div>
          </b-card>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {getCache,storedCache} from '@/cache'
import constant from '../../utils/constant.js';
export default {
  data () {
    return {
        isLoading: true,
        isModalVisible: false,
        selected : null,
        payments:[]
    }
  },
  created(){
     this.getPayments()
  },
  beforeMount()
  {
    
  },
  watch: {
    '$route' : 'getpayments'
  },
  methods:{
      openSpinner()
      {
        this.isLoading = true
      },
      closeSpinner()
      {
        this.isLoading = false
      },
      confirm(id)
      {
        const token = localStorage.getItem(`user_token`);
        const community_id = localStorage.getItem('user_id');
        this.$swal({
          title: 'Konfirmasi ',
          text: 'Apakah anda yakin konfimasi pembayaran ini ?',
          type: 'error',
          showCancelButton: true,
          confirmButtonText: 'Yes Confirm!',
          cancelButtonText: 'No, Cancel!',
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then((result) => {
          if(result.value) {
              axios.put(constant._BASE_URL+"payment/"+id,"",{
                headers:{
                    'Content-type': 'application/json',
                    'Authorization' : 'Bearer '+token,
                }
              }).then(response => {
                    let message = response.data.success
                    console.log(message)
                    this.$swal('Konfirmasi', message , 'success')
                    this.getPayments()
              })
          } else {
    
          }
        })
      },
      getPayments()
      {
        const token = localStorage.getItem(`user_token`);
        const community_id = localStorage.getItem('user_id');
        this.openSpinner()
        axios.get(constant._BASE_URL+"payment",{
            headers:{
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
            }
        }).then(response =>{
            storedCache(`payments_detail`+community_id, response.data)
            this.payments = getCache(`payments_detail`+community_id)
            this.closeSpinner()
        }).catch(error => {
            console.log(error)
            this.payments = getCache(`payments_detail`+community_id)
            this.closeSpinner()
        });
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
  }
}
</script>
<style scoped>
.imageFile {
  height: 150px;
}
.imageHome {
  width: 30%;
  display: inline-block;
  margin-left: 0dp;
  margin-right: 0dp;
}
</style>



// WEBPACK FOOTER //
// src/components/pembayaran/Pembayaran.vue